// Dependencies
import Vue from 'vue'
import { Carousel, Slide } from 'vue-carousel'

// Components
import PosterPreview from '@/components/poster-preview/component'

Vue.use(Carousel)

export default {
  name: 'inspiration-component',
  components: { PosterPreview, Carousel, Slide },
  data () {
    return {
      posters: [
        'born-strong',
        'blossom-a',
        'mockingbird',
        'blossom-e'
      ]
    }
  },

  mounted () {
    let postersMetadata = []
    const _this = this
    this.posters.forEach(function (poster) {
      postersMetadata.push(_this.$store.getters.postersMetaData[poster])
    })
    this.$store.dispatch('trackViewPosters', {
      list: 'inspiration',
      posters: postersMetadata
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/inspiration/script.js